import React, { useCallback, useEffect, useState } from 'react';
import { Grid, Typography, Button,Link } from '@mui/material';
import VideoLandingGif from './assests/images/newimages/landinganimation.gif';
import VideoLandingGifFrench from './assests/images/newimages/landinganimation_french.gif';
import VideoLandingGifSpanish from './assests/images/newimages/landinganimation_spanish.gif';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { useNavigate } from "react-router";

const gif = {
  en: VideoLandingGif,
  fr: VideoLandingGifFrench,
  es: VideoLandingGifSpanish,
};

function DesktopLandingSection() {
  const { i18n } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);
  const currentLanguage = i18n.language;
  const navigate = useNavigate()

  const locale = useSelector((state) => state.language.langData)

  const proceedToNxtPrivacy = useCallback(() => {
    window.open(`https://aloxa.ai/privacy-policy?lang=${locale}`, "_blank");
  }, [locale]);

  const proceedToNxtService = useCallback(() => {
    window.open(`https://aloxa.ai/terms-of-service?lang=${locale}`, "_blank");
  }, [locale]);

  useEffect(() => {
    if (!window.cordova) {
      let isMobile = /iPhone|iPod|iPad|Android/i.test(navigator.userAgent);
      if (!isMobile) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
      }
    }
  }, [isMobile]);

  // useEffect(() => {
  //   Cookies.set('gender', 'female', { expires: 365 })
  // }, [])

  return (
    <div className='desktopDivShow' id='desktopLanding'> 
          <div className='desktopGifDetails'>
          {/* <h6 className='headingDiv'>{i18next.t("Take Control of Your Hair Health—Backed by Science")}</h6>
          <span className='spanPara'>{i18next.t("Just a few photos to start the analysis.")}</span>
          <h5>{i18next.t("Upload. Analyze. Understand.")}</h5> */}
          {/* <Button className='commonButton' href='https://aloxa.ai/feedback' target='_blank'>
          {i18next.t("Beta Test Feedback")}</Button> */}
        <h5 className='headingDiv'>{i18next.t("Get your Personalised Hair Loss Analysis Report")}</h5>
      </div>
      <div>
        <img src={gif[currentLanguage]} alt="Loading animation" width="300" className='videoGif' />
      </div>
      <div className='desktopGifDetails2'>
        <span className='spanPara'>{i18next.t("Our AI uses over 100,000 hair health data points to assess")}</span>
        <span className='spanPara second'>{i18next.t("the condition of your scalp and hairline")}</span>
        <h6 className={isMobile && 'buttonTakeTest'} onClick={() => {
                  // setTakeTest(true)
                  isMobile && navigate('/loginpage')
                }}>{i18next.t("Take the AI Hair Test")}</h6>
        </div>
          
          {/* <div className="mt-5px footerDiv"> */}
          {/* <div>
            <Typography className='footerName'>{i18next.t("© 2025 aloxa.ai All Rights Reserved")}</Typography>
          </div>
        <div>
        <Link onClick={proceedToNxtPrivacy} className="linkName">
          <Typography className="footerName">{i18next.t("Privacy Policy")}</Typography>
          </Link>
        </div>
        <div className='text-left'>
        <Link onClick={proceedToNxtService} className="linkName">
          <Typography className="footerName">{i18next.t("Terms of Service")}</Typography>
          </Link>
        </div> */}
        {/* <Grid item xs={6}></Grid> */}
      {/* </div>
      */}
    </div>
  )
}

export default DesktopLandingSection